<p
  class="tw-mt-5 tw-px-5 tw-pb-0.5 tw-font-sans tw-text-sm tw-text-eerie-black sm:tw-mt-10 sm:tw-px-0 sm:tw-text-base"
>
  {{ 'screens.notaryInformation.requiredFields' | translate }}
</p>
<form
  (ngSubmit)="inheritanceFacade.onNext()"
  [formGroup]="inheritanceFacade.inheritanceInformationForm"
  iaInvalidControlScroll
>
  <ia-panel class="tw-mt-4 tw-block">
    <div header class="">
      <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
        'screens.inheritanceInformation.introduction.title' | translate
      }}</span>
    </div>
    <div content class="tw-px-8 tw-pb-6 tw-pt-5">
      <p class="tw-font-sans tw-text-sm sm:tw-text-base">
        {{ 'screens.inheritanceInformation.information.description' | translate }}
      </p>
      <div>
        @if (inheritanceFacade.showSpouse$ | async) {
          <ia-succession-heir-information-form
            [formGroup]="inheritanceFacade.spouse"
            [title]="'screens.inheritanceInformation.information.spouse.label' | translate"
          />
        }

        <div class="tw-mt-7.5">
          <label
            for="input-deceased-more-information-funeral-contract"
            id="label-deceased-more-information-funeral-contract"
            class="tw-pb-4 tw-font-sans tw-text-base tw-font-semibold"
            >{{ 'screens.inheritanceInformation.information.hasChildren.label' | translate }}</label
          >
          @for (
            object of successionFacade.listBoxItems.yesNoIdk;
            track object;
            let index = $index
          ) {
            <ia-radio-button
              aria-describedby="hasChildren"
              class="first-letter:tw-uppercase"
              type="radio"
              [value]="object.value"
              groupName="hasChildren"
              formControlName="hasChildren"
            >
              {{ object.label }}
            </ia-radio-button>
          }
          @if (inheritanceFacade.hasChildren.touched && inheritanceFacade.hasChildren.invalid) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.inheritanceInformation.information.hasChildren.error' | translate }}
            </p>
          }
        </div>

        @if (this.inheritanceFacade.hasChildren.value === 'YES') {
          <div class="tw-mt-7.5" formArrayName="children">
            @for (child of inheritanceFacade.children.controls; track child; let i = $index) {
              <ia-succession-heir-information-form
                [title]="
                  ('screens.inheritanceInformation.information.children.label' | translate) +
                  (i + 1)
                "
                [formGroup]="inheritanceFacade.getChildFormGroup(i)"
                [removable]="inheritanceFacade.getChildFormGroup(i).enabled"
                (remove)="inheritanceFacade.removeChild(i)"
              />
            }
            <div class="tw-flex tw-justify-center sm:tw-justify-start">
              <button
                (click)="inheritanceFacade.addChild()"
                class="tw-mb-10 tw-mt-5 tw-flex tw-h-10.5 tw-w-52.5 tw-rounded-3xl tw-bg-kepel tw-px-7.5 tw-py-2.5 tw-font-sans tw-font-semibold tw-text-white"
                data-test-id="btn-add-inheritance-info"
              >
                <span>+ </span>
                {{ 'screens.inheritanceInformation.information.button.add' | translate }}
              </button>
            </div>
          </div>
        }
      </div>
    </div></ia-panel
  >
  @if (
    {
      isLoading: successionFacade.customerInformationIsLoading$ | async,
      isPrevious: successionFacade.isPreviousPageLoading$ | async,
      isNext: successionFacade.isNextPageLoading$ | async,
    };
    as vm
  ) {
    <div
      class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-space-y-2 sm:tw-flex-row sm:tw-space-x-2 sm:tw-space-y-0"
    >
      <button
        (click)="inheritanceFacade.onPrevious()"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isPrevious"
        iaButton
        id="btn-notary-more-information-previous"
        data-test-id="btn-notary-more-information-previous"
        type="button"
        variant="secondary"
      >
        {{ 'screens.notaryInformation.information.button.previous' | translate }}
      </button>
      <button
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isNext"
        iaButton
        id="btn-notary-information-next"
        data-test-id="btn-notary-information-next"
        type="submit"
        variant="primary"
      >
        {{ 'screens.notaryInformation.information.button.next' | translate }}
      </button>
    </div>
  }
</form>
